export default __webpack_public_path__ + "static/media/create.ddc139c9.svg";